import { gql } from 'apollo-boost';

// User
export const LOGIN_MUTATION = gql`
  mutation LoginMutation($input: LoginMutationInput!) {
    login(input: $input) {
      session {
        id
      }
      user {
        id
        firstName
        lastName
        email
      }
      mfaChallenge {
        session
        phoneNumber
      }
    }
  }
`;

export const REGISTER_USER_MUTATION = gql`
  mutation RegisterMutation($input: RegisterMutationInput!) {
    register(input: $input) {
      user {
        id
        email
        firstName
        lastName
        birthdate
      }
    }
  }
`;

export const VERIFY_EMAIL_MUTATION = gql`
  mutation VerifyRegistrationEmailMutation($input: VerifyRegistrationEmailMutationInput!) {
    verifyRegistrationEmail(input: $input) {
      success
    }
  }
`;

export const VERIFY_MFA_MUTATION = gql`
  mutation MfaVerificationMutation($input: MfaVerificationMutationInput!) {
    mfaVerification(input: $input) {
      session {
        id
      }
      user {
        id
        firstName
        lastName
        email
      }
    }
  }
`;

// Opportunity
export const CREATE_OPPORTUNITY_MUTATION = gql`
  mutation CreateOpportunityMutation($input: CreateOpportunityV2MutationInput!) {
    createOpportunityV2(input: $input) {
      newOpportunity {
        id
        name
        groupId
        eventId
      }
    }
  }
`;

export const UPDATE_OPPORTUNITY_MUTATION = gql`
  mutation EditOpportunityMutation($input: EditOpportunityV2MutationInput!) {
    editOpportunityV2(input: $input) {
      opportunity {
        id
        name
      }
    }
  }
`;

// Group
export const UPDATE_GROUP_MUTATION = gql`
  mutation SaveGroupMutation($input: SaveGroupMutationInput!) {
    saveGroup(input: $input) {
      group {
        id
        name
        summary
        type
        industry
        insurances {
          insuranceType
          vendor
          value
          expiryDate
        }
        avatarUrl
        bannerUrl
        draft
      }
    }
  }
`;

export const CREATE_GROUP_MUTATION = gql`
  mutation SaveGroupMutation($input: SaveGroupMutationInput!) {
    saveGroup(input: $input) {
      group {
        id
        name
        summary
        type
        industry
      }
    }
  }
`;

export const REQUEST_PARTNERSHIP_MUTATION = gql`
  mutation requestPartnershipMutation($input: RequestPartnershipMutationInput!) {
    requestPartnership(input: $input) {
      partnership {
        id
        requesterId
        requesteeId
        reason
        status
        createdAt
      }
    }
  }
`;

export const FORCE_PASSWORD_CHANGE_MUTATION = gql`
  mutation ForcePasswordChangeMutation($input: ForcePasswordChangeMutationInput!) {
    forcePasswordChange(input: $input) {
      session {
        id
      }
      user {
        id
        email
      }
    }
  }
`;
